import { createStore } from 'shalala';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import AppStore from '../app/AppStore';
import AdminStore from '../admin/AdminStore';
import CuentaStore from '../cuenta/CuentaStore';
import ModuloStore from '../modulos/ModuloStore';
import ExternalStore from '../external/ExternalStore';
import DeveloperStore from '../developers/DeveloperStore';
import EmpresaTenantStore from '../layouts/state/EmpresaTenantStore';

const store = {
  app: AppStore,
  admin: AdminStore,
  cuenta: CuentaStore,
  external: ExternalStore,
  developer: DeveloperStore,
  layouts: {
    empresa: {
      tenant: EmpresaTenantStore,
    },
  },
  modulo: ModuloStore,
};

const globalStore = createStore(store, null, {
  plugins: [devtools, immer],
});

const { useStore, useGlobal, resetStore } = globalStore;

export { useStore, resetStore };

export default useGlobal;
